import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase-config";
import '../../assets/styles/AdminShared.css';

const questions = [
  "Do all pages load correctly and quickly on both desktop and mobile?",
  "Are there any broken links or buttons?",
  "Are all forms (contact, sign-up, etc.) working correctly?",
  "Is the content free of typos, grammar issues, or outdated info?",
  "Does the design match your expectations on all devices?",
  "Are all animations, transitions, and hover states functioning smoothly?",
  "Does the website work across different browsers (Chrome, Safari, Firefox)?",
  "Are third-party tools (Calendly, payment gateways, etc.) integrated and functional?",
  "Is the favicon and metadata correctly set (title, description)?",
  "Do you have any final requests or changes before we launch?"
];

const AdminTestingQA = () => {
  const { projectId } = useParams();
  const [projectName, setProjectName] = useState("Loading...");
  const [responses, setResponses] = useState({});
  const [approval, setApproval] = useState(false);
  const [previewLink, setPreviewLink] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const projectRef = doc(db, "projects", projectId);
        const projectSnap = await getDoc(projectRef);

        if (projectSnap.exists()) {
          const data = projectSnap.data();
          setProjectName(data.projectName || "Unnamed Project");
          setResponses(data.revisionDetails?.testingQA?.form?.responses || {});
          setApproval(data.revisionDetails?.testingQA?.form?.approval || false);
          setPreviewLink(data.revisionDetails?.testingQA?.link || "");
        } else {
          throw new Error("Project not found.");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [projectId]);

  return (
    <div className="ap-page">
      <div className="ap-page-header">
        <a href="/admin" className="ap-back">← Back to dashboard</a>
        <p className="ap-eyebrow">Admin — Testing & QA</p>
        <h1 className="ap-title">{projectName}: Testing & QA Review</h1>
        <p className="ap-subtitle">Read-only view of the client's final checklist before launch.</p>
      </div>

      {loading ? (
        <div className="ap-loading"><p>Loading...</p></div>
      ) : error ? (
        <div className="ap-loading ap-loading--error"><p>{error}</p></div>
      ) : (
        <>
          {previewLink && (
            <div className="ap-section" style={{ marginBottom: '24px' }}>
              <div className="ap-section-header">
                <h2 className="ap-section-title">Website Preview</h2>
              </div>
              <div className="ap-section-body">
                <div className="ap-link-display">
                  <a
                    href={previewLink.startsWith("http") ? previewLink : `https://${previewLink}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {previewLink.startsWith("http") ? previewLink : `https://${previewLink}`}
                  </a>
                </div>
              </div>
            </div>
          )}

          <div className="ap-section">
            <div className="ap-section-header">
              <h2 className="ap-section-title">Client Responses</h2>
            </div>
            <div className="ap-section-body">
              <ul className="ap-checklist">
                {questions.map((question, index) => (
                  <li key={index} className="ap-checklist-item">
                    <input
                      type="checkbox"
                      checked={responses[question] || false}
                      readOnly
                    />
                    <span>{question}</span>
                  </li>
                ))}
                <li className="ap-checklist-item">
                  <input type="checkbox" checked={approval} readOnly />
                  <span>Client approved this project for launch.</span>
                </li>
              </ul>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AdminTestingQA;
